import React, { useEffect, useState } from "react";

const DataTableHeader = ({
  pageSize,
  setPageSize,
  globalFilter,
  setGlobalFilter,
  setCurrentPage,
  setGloablFilterType,
  gloablFilterType,
  flage,
  filtersOptions
}) => {
  const sizeOptions = [5, 10, 25];
  const FilterOptions = ["Phone", "Name"];
  const [dynamicOptions,setDynamicOptions]= useState([])

  useEffect(()=>
  {
    setDynamicOptions(filtersOptions)
  },[filtersOptions])

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1); // Reset to first page
  };

  const handleFilterChange = (e) => {
    setGloablFilterType(e.target.value);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      {flage !== "mainReports" ? (
        <div className="d-flex align-items-center">
          Show{" "}
          <select
            value={pageSize}
            onChange={handlePageSizeChange}
            className="form-select form-select-sm ms-2"
          >
            {sizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>{" "}
        </div>
      ) : (
        <div className="d-flex align-items-center">
          {" "}
         
        </div>
      )}

      <div className="d-flex gap-4 align-items-center">
        {flage === "guestList" || flage === "offers" || flage === "packages" ? (
          <>
            <div>
              <select
                value={gloablFilterType}
                onChange={handleFilterChange}
                className="form-select form-select-sm ms-2"
              >
                {filtersOptions
                  ? dynamicOptions.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))
                  : FilterOptions.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
              </select>
            </div>
          </>
        ) : (
          <></>
        )}
      {flage !== "category" && (
        <div className="d-flex gap-1 align-items-center">
          <span className="me-2">Search:</span>
          <input
            value={globalFilter}
            onChange={(e) => {
              setGlobalFilter(e.target.value);
              setCurrentPage(1); // Reset to first page
            }}
            placeholder={
              flage === "roomList" ? "room number . . " : "search here . ."
            }
            className="form-control form-control-sm"
          />
        </div>
    )}
      </div>
    </div>
  );
};

export default DataTableHeader;
